document.querySelectorAll(".dropdown-toggle").forEach((button) => {
  button.addEventListener("click", (e) => {
    const wrapper = button.closest(".dropdown-wrapper");
    wrapper.classList.toggle("open");

    // Close others
    document.querySelectorAll(".dropdown-wrapper").forEach((item) => {
      if (item !== wrapper) item.classList.remove("open");
    });
  });
});

// Optional: close dropdown when clicking outside
document.addEventListener("click", (e) => {
  if (!e.target.closest(".dropdown-wrapper")) {
    document
      .querySelectorAll(".dropdown-wrapper")
      .forEach((item) => item.classList.remove("open"));
  }
});

document.querySelectorAll(".submenu-toggle").forEach((button) => {
  button.addEventListener("click", () => {
    const parent = button.closest(".has-submenu");
    parent.classList.toggle("open");
  });
});

const mobileMenuButton = document.querySelector("#mobile-menu-button");
const mobileMenu = document.querySelector("#mobile-menu-drawer");

if (mobileMenuButton && mobileMenu) {
  mobileMenuButton.addEventListener("click", () => {
    mobileMenuButton.classList.toggle("open");
    mobileMenu.classList.toggle("open");
  });
}

//=======================================================================
//                         Custom Slider Section
//=======================================================================

window.addEventListener("load", () => {
  const nextButton = document.querySelector("#next-slide");
  const previousButton = document.querySelector("#previous-slide");
  const slide = document.querySelector(".cards-wrapper");

  if (nextButton && slide) {
    nextButton.addEventListener("click", () => {
      slide.scrollBy({ left: -270, behavior: "smooth" });
    });
  }

  if (previousButton && slide) {
    previousButton.addEventListener("click", () => {
      slide.scrollBy({ left: 270, behavior: "smooth" });
    });
  }
});

//=======================================================================
//                              FAQ Section
//=======================================================================

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-question").forEach(function (question) {
    question.addEventListener("click", function () {
      const item = this.closest(".faq-item");
      item.classList.toggle("active");
    });
  });
});

// PK - Subtotal label + price-per-unit + subtotal + savings
document.addEventListener("DOMContentLoaded", function () {
  // 1) Find the "Subtotal" field by label text
  const labels = document.querySelectorAll(".custom-product-section label");
  let subtotalField = null;

  labels.forEach(function (label) {
    const text = label.textContent.replace(":", "").trim().toLowerCase();
    if (text === "subtotal" && !subtotalField) {
      subtotalField =
        label.closest(".pk-subtotal-field") ||
        label.closest(".product-options") ||
        label.parentElement;
    }
  });

  if (!subtotalField) return;

  // 2) Grab the SELECT that holds "$1600 Save 84%" etc
  const select = subtotalField.querySelector("select");
  if (!select) return;

  // 3) Hide the original dropdown completely
  const customSelect = subtotalField.querySelector(".custom-select");
  if (customSelect && customSelect.style) {
    customSelect.style.display = "none";
  }
  select.style.display = "none";

  // 4) Create our clean subtotal row container
  const wrapper = subtotalField;
  const display = document.createElement("div");
  display.className = "pk-subtotal-display";
  display.innerHTML = `
    <span class="pk-subtotal-each"></span>
    <span class="pk-subtotal-dot">•</span>
    <span class="pk-subtotal-label">Subtotal:</span>
    <span class="pk-subtotal-total"></span>
    <span class="pk-subtotal-save"></span>
  `;
  wrapper.appendChild(display);

  const eachSpan = display.querySelector(".pk-subtotal-each");
  const totalSpan = display.querySelector(".pk-subtotal-total");
  const saveSpan = display.querySelector(".pk-subtotal-save");

  function updateSubtotal() {
    const opt = select.options[select.selectedIndex];
    const raw = opt && opt.text ? opt.text.trim() : "";

    if (!raw) {
      eachSpan.textContent = "";
      totalSpan.textContent = "";
      saveSpan.textContent = "";
      return;
    }

    // Expect something like: "$1600 Save 84%"
    const saveMatch = raw.match(/Save\s*\d+%/i);
    const saveText = saveMatch ? saveMatch[0].trim() : "";
    const priceText = saveMatch ? raw.replace(saveMatch[0], "").trim() : raw;

    // Price per unit
    eachSpan.textContent = priceText;

    // Subtotal amount
    totalSpan.textContent = priceText;

    // Savings
    saveSpan.textContent = saveText;
  }

  updateSubtotal();
  select.addEventListener("change", updateSubtotal);
});

// Hard-remove the original "Subtotal" label
document.addEventListener("DOMContentLoaded", function () {
  var labels = document.querySelectorAll(
    ".custom-product-section label, .custom-product-section .product-form__label"
  );

  labels.forEach(function (label) {
    var text = (label.textContent || "")
      .replace(":", "")
      .trim()
      .toLowerCase();
    if (text === "subtotal") {
      label.style.setProperty("display", "none", "important");
    }
  });
});

// Packora: keep "price per unit (each)" in sync with subtotal & quantity
document.addEventListener("DOMContentLoaded", function () {
  const subtotalField = document.querySelector(".pk-subtotal-field");
  if (!subtotalField) return;

  const priceEachSpan = subtotalField.querySelector(".pk-subtotal-each");
  const subtotalSpan = subtotalField.querySelector(".pk-subtotal-total");
  if (!priceEachSpan || !subtotalSpan) return;

  // Try to locate the Quantity <select> by finding the "Quantity" label
  let qtySelect = null;
  const allNodes = Array.from(
    document.querySelectorAll(".custom-product-section *")
  );

  allNodes.forEach(function (node) {
    if (qtySelect) return;

    const text = (node.textContent || "")
      .replace(":", "")
      .trim()
      .toLowerCase();

    if (text === "quantity") {
      const field =
        node.closest(".custom-product-section-field") ||
        node.closest(".po-field");
      if (field) {
        qtySelect = field.querySelector("select");
      }
    }
  });

  function recalcUnitPrice() {
    if (!subtotalSpan || !priceEachSpan || !qtySelect) return;

    const subtotalText = subtotalSpan.textContent || "";
    const amountMatch = subtotalText.replace(/[^0-9.]/g, "");
    const amount = parseFloat(amountMatch);
    if (!amount) return;

    let qty = 1;
    const opt = qtySelect.options[qtySelect.selectedIndex];

    if (opt) {
      const optText = opt.textContent || "";
      const numMatch = optText.match(/(\d+(\.\d+)?)/);
      if (numMatch) {
        qty = parseFloat(numMatch[1]);
      }
    } else if (qtySelect.value) {
      qty = parseFloat(qtySelect.value);
    }

    if (!qty || qty <= 0) qty = 1;

    const unit = amount / qty;
    priceEachSpan.textContent = `$${unit.toFixed(2)} each`;
  }

  recalcUnitPrice();

  const observer = new MutationObserver(recalcUnitPrice);
  observer.observe(subtotalSpan, {
    childList: true,
    characterData: true,
    subtree: true,
  });

  if (qtySelect) {
    qtySelect.addEventListener("change", recalcUnitPrice);
  }
});

// Packora - dynamic price-per-unit using quantity only
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".custom-product-section");
  if (!section) return;
if (window.PACKORA_SHIPPING_BOXES_URL) return;
  if (section.hasAttribute("data-packora-pricing-url")) return;

  let qtySelect = null;
  const labels = section.querySelectorAll("label");

  labels.forEach(function (label) {
    const text = (label.textContent || "")
      .replace(":", "")
      .trim()
      .toLowerCase();

    if (text === "quantity" && !qtySelect) {
      const field =
        label.closest(".custom-product-section__field") ||
        label.closest(".po-field") ||
        label.parentElement;

      if (field) {
        qtySelect = field.querySelector("select");
      }
    }
  });

  if (!qtySelect) return;

  const subtotalDisplay = section.querySelector(".pk-subtotal-display");
  if (!subtotalDisplay) return;

  const eachSpan = subtotalDisplay.querySelector(".pk-subtotal-each");
  const totalSpan = subtotalDisplay.querySelector(".pk-subtotal-total");

  if (!eachSpan || !totalSpan) return;

  function formatMoney(amount) {
    return "$" + amount.toFixed(2);
  }
if (typeof BASE_UNIT_PRICE === 'undefined') return;
  function updatePricePerUnit() {
    let qty = parseInt(qtySelect.value, 10);
    if (!qty || qty < 1) qty = 1;

    const unitPrice = BASE_UNIT_PRICE; // relies on existing global
    const subtotal = unitPrice * qty;

    eachSpan.textContent = formatMoney(unitPrice);
    totalSpan.textContent = formatMoney(subtotal);
  }

  updatePricePerUnit();
  qtySelect.addEventListener("change", updatePricePerUnit);
});

// =======================================================
// Packora – Shipping Boxes dynamic pricing from JSON
// (uses PACKORA_SHIPPING_BOXES_URL)
// =======================================================
document.addEventListener("DOMContentLoaded", function () {
  if (!window.PACKORA_SHIPPING_BOXES_URL) {
    return;
  }

  var root = document.querySelector(".custom-product-section");
  if (!root) {
    console.warn("[Packora shipping] .custom-product-section not found");
    return;
  }

  var priceEachSpan = root.querySelector(".pk-subtotal-each");
  var subtotalSpan = root.querySelector(".pk-subtotal-total");

  if (!priceEachSpan || !subtotalSpan) {
    console.warn("[Packora shipping] subtotal spans not found");
    return;
  }

  function findSelectByLabel(labelNeedle) {
    labelNeedle = labelNeedle.toLowerCase();
    var labels = root.querySelectorAll("label");
    for (var i = 0; i < labels.length; i++) {
      var text = (labels[i].textContent || "")
        .replace(":", "")
        .trim()
        .toLowerCase();

      if (text.indexOf(labelNeedle) === -1) continue;

      var field =
        labels[i].closest(".custom-product-section__field") ||
        labels[i].closest(".product-form__input") ||
        labels[i].parentElement;

      if (!field) continue;
      var select = field.querySelector("select");
      if (select) return select;
    }
    return null;
  }

  var sizeSelect = findSelectByLabel("size");
  var materialSelect = findSelectByLabel("material");
  var sidesSelect = findSelectByLabel("printed sides");
  var qtySelect = findSelectByLabel("quantity");

  if (!sizeSelect || !materialSelect || !sidesSelect || !qtySelect) {
    console.warn("[Packora shipping] missing one or more selects", {
      sizeSelect: !!sizeSelect,
      materialSelect: !!materialSelect,
      sidesSelect: !!sidesSelect,
      qtySelect: !!qtySelect,
    });
    return;
  }

  function normSize(str) {
  if (!str) return "";
  return String(str)
    .toLowerCase()
    .replace(/×/g, "x")
    .replace(/[^0-9x]/g, "");
}

  function normMaterial(str) {
    str = (str || "").toLowerCase();
    if (str.indexOf("kraft") !== -1) return "kraft";
    return "white";
  }

  function normSides(str) {
    str = (str || "").toLowerCase();
    if (str.indexOf("blank") !== -1) return "blank";
    if (str.indexOf("both") !== -1) return "both";
    if (str.indexOf("inside") !== -1) return "inside";
    if (str.indexOf("outside") !== -1) return "outside";
    return "outside";
  }

  function getConfigFromUI() {
    var sizeText = sizeSelect.options[sizeSelect.selectedIndex].text;
    var materialText = materialSelect.options[materialSelect.selectedIndex].text;
    var sidesText = sidesSelect.options[sidesSelect.selectedIndex].text;

    var qtyRaw =
      qtySelect.value ||
      (qtySelect.options[qtySelect.selectedIndex] || {}).text ||
      "1";
    var qty = parseInt(qtyRaw, 10);
    if (!qty || isNaN(qty)) qty = 1;

    return {
      size: normSize(sizeText),
      material: normMaterial(materialText),
      sides: normSides(sidesText),
      quantity: qty,
    };
  }

  var grid = [];

function getRowVal(row, keys) {
  for (var i = 0; i < keys.length; i++) {
    var k = keys[i];
    if (row && row[k] != null && row[k] !== "") return row[k];
  }
  return null;
}

function findRow(config) {
  for (var i = 0; i < grid.length; i++) {
    var row = grid[i];

    var rowSize = getRowVal(row, ["interior_dimensions","size","dimensions","dimension"]);
    var rowMat  = getRowVal(row, ["material","stock","paper"]);
    var rowSide = getRowVal(row, ["printed_sides","printed_side","sides","print_sides"]);
    var rowQty  = getRowVal(row, ["quantity","qty","q"]);

    if (
      normSize(rowSize) === config.size &&
      normMaterial(rowMat) === config.material &&
      normSides(rowSide) === config.sides &&
      Number(rowQty) === config.quantity
    ) {
      return row;
    }
  }
  return null;
}

  function formatMoney(value) {
    var n = Number(value);
    if (!isFinite(n)) return "—";
    return "$" + n.toFixed(2);
  }

  function setHiddenPackoraPricing(unit, total, qty) {
    var unitInput = document.getElementById("packora-unit-price");
    var subtotalInput = document.getElementById("packora-subtotal");
    var qtyInput = document.getElementById("packora-qty");

    if (unitInput && isFinite(unit)) {
      unitInput.value = Number(unit).toFixed(2);
    }
    if (subtotalInput && isFinite(total)) {
      subtotalInput.value = Number(total).toFixed(2);
    }
    if (qtyInput && qty != null) {
      qtyInput.value = String(qty);
    }
  }

function updateFromGrid() {
  if (!grid.length) return;

  var cfg = getConfigFromUI();
  var row = findRow(cfg);

  if (!row) {
    console.warn("[Packora shipping] No price row for selection", cfg);
    priceEachSpan.textContent = "—";
    subtotalSpan.textContent = "—";
    setHiddenPackoraPricing(null, null, cfg.quantity);
    return;
  }

  var unitPrice = Number(getRowVal(row, [
  "unit_price","unit","unitPrice","price_each","each","packora_unit_price","packora_price_per_unit"
]));

var totalPrice = Number(getRowVal(row, [
  "total_price","total","subtotal","totalPrice","packora_subtotal","packora_total_price"
]));

// Fallback: compute missing side
if (!isFinite(totalPrice) && isFinite(unitPrice)) totalPrice = unitPrice * cfg.quantity;
if (!isFinite(unitPrice) && isFinite(totalPrice) && cfg.quantity) unitPrice = totalPrice / cfg.quantity;

  priceEachSpan.innerHTML =
    '<span class="pk-price-main">' +
    formatMoney(unitPrice) +
    '</span><span class="pk-price-label"></span>';
  subtotalSpan.textContent = formatMoney(totalPrice);

  setHiddenPackoraPricing(unitPrice, totalPrice, cfg.quantity);

  // ✅ MUST BE INSIDE updateFromGrid()
  if (window.Packora && typeof window.Packora.setPricing === 'function') {
    window.Packora.setPricing({ qty: cfg.quantity, unit: unitPrice, subtotal: totalPrice });
  }
  if (window.Packora && typeof window.Packora.syncSnapshot === 'function') {
    window.Packora.syncSnapshot();
  }
}
  fetch(window.PACKORA_SHIPPING_BOXES_URL)
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      grid = Array.isArray(data) ? data : [];
      console.log("[Packora shipping] Grid loaded:", grid.length, "rows");
      updateFromGrid();
      [sizeSelect, materialSelect, sidesSelect, qtySelect].forEach(function (el) {
        el.addEventListener("change", updateFromGrid);
      });
    })
    .catch(function (err) {
      console.error("[Packora shipping] Failed to load JSON", err);
    });
});

// =======================================================
// Packora — Universal JSON pricing engine (ALL products)
// Requires markup in main-product.liquid:
//   .custom-product-section[data-packora-pricing-url="..."]
//   .pk-price-main      (big blue $/unit)
//   .pk-subtotal-total  (grey subtotal)
// =======================================================
document.addEventListener("DOMContentLoaded", function () {
  const root = document.querySelector(".custom-product-section");
  if (!root) return;

  if (window.PACKORA_SHIPPING_BOXES_URL) return;

  const pricingUrl = root.getAttribute("data-packora-pricing-url");
  if (!pricingUrl) return;

  const priceMain = root.querySelector(".pk-price-main");
  const subtotalEl = root.querySelector(".pk-subtotal-total");

  if (!priceMain || !subtotalEl) {
    console.warn("[Packora JSON] Missing .pk-price-main or .pk-subtotal-total");
    return;
  }

  if (window.PACKORA_SHIPPING_BOXES_URL) return;

  const normText = (s) =>
    String(s || "")
      .replace(/\u00a0/g, " ")
      .replace(/[:]/g, "")
      .trim()
      .toLowerCase();

  const normKeyFromLabel = (labelText) =>
    normText(labelText)
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_");

  const normQuantity = (valOrText) => {
    const m = String(valOrText || "").match(/(\d+(\.\d+)?)/);
    return m ? Number(m[1]) : null;
  };

  const formatMoney = (value) => {
    const n = Number(value);
    if (!isFinite(n)) return "—";
    return "$" + n.toFixed(2);
  };

  function renderEmpty() {
    priceMain.textContent = "—";
    subtotalEl.textContent = "—";
  }

  function renderPrices(unit, total) {
    priceMain.textContent = formatMoney(unit);
    subtotalEl.textContent = formatMoney(total);
  }

  function setHiddenPackoraPricing(unit, total, cfg) {
    const unitInput = document.getElementById("packora-unit-price");
    const subtotalInput = document.getElementById("packora-subtotal");
    const qtyInput = document.getElementById("packora-qty");

    if (unitInput && isFinite(unit)) {
      unitInput.value = Number(unit).toFixed(2);
    }
    if (subtotalInput && isFinite(total)) {
      subtotalInput.value = Number(total).toFixed(2);
    }

    if (qtyInput && cfg && typeof cfg === "object") {
      let qty = 1;
      const qtyKey = Object.keys(cfg).find(function (k) {
        return (
          k.indexOf("quantity") !== -1 ||
          k.indexOf("rolls") !== -1 ||
          k === "qty"
        );
      });
      if (qtyKey && typeof cfg[qtyKey] === "number") {
        qty = cfg[qtyKey];
      }
      qtyInput.value = String(qty);
    }
  }

  (function hideNativeSubtotalField() {
    root.querySelectorAll("label").forEach((label) => {
      if (normText(label.textContent) === "subtotal") {
        const field =
          label.closest(
            ".custom-product-section__field, .po-field, .product-form__input, .product-options"
          ) || label.parentElement;
        if (field) field.style.setProperty("display", "none", "important");
      }
    });
  })();

  function getLabeledSelects() {
    const fields = [];
    const wrappers = root.querySelectorAll(
      ".custom-product-section__field, .po-field, .product-form__input, .product-options"
    );

    wrappers.forEach((wrap) => {
      const sel = wrap.querySelector("select");
      const lab = wrap.querySelector("label");
      if (!sel || !lab) return;
      const key = normKeyFromLabel(lab.textContent);
      if (!key) return;
      fields.push({ key, select: sel });
    });

    if (!fields.length) {
      root.querySelectorAll("select").forEach((sel) => {
        const wrap =
          sel.closest(
            ".custom-product-section__field, .po-field, .product-form__input, .product-options"
          ) || sel.parentElement;
        const lab = wrap ? wrap.querySelector("label") : null;
        if (!lab) return;
        fields.push({ key: normKeyFromLabel(lab.textContent), select: sel });
      });
    }

    return fields;
  }

  function normValueByKey(key, val) {
    const v = normText(val);

    if (key === "hang_hole") {
      if (v === "no" || v === "none") return "none";
    }

    if (key === "printed_sides") {
      if (v.includes("blank")) return "blank";
      if (v.includes("front") || v.includes("outside")) return "outside only";
      if (v.includes("inside")) return "inside only";
      if (v.includes("both")) return "both sides";
      return v;
    }

    if (key === "colors") {
      const m = v.match(/(\d+)/);
      return m ? m[1] : v;
    }

    if (key === "lamination" || key === "laminate" || key === "finish") {
      if (v.includes("gloss")) return "gloss";
      if (v.includes("matte")) return "matte";
      if (v.includes("soft") && v.includes("touch")) return "soft touch laminate";
      return v;
    }

    return v;
  }

  const labeled = getLabeledSelects();

  const IGNORE_KEYS = new Set([
    "production_time",
    "production",
    "background_color",
    "logo_pattern",
  ]);

  const pricingFields = labeled.filter((f) => f.key && !IGNORE_KEYS.has(f.key));

  function readSelection() {
    const cfg = {};
    pricingFields.forEach(({ key, select }) => {
      const optText = select.options[select.selectedIndex]?.text || "";
      if (key.includes("quantity") || key.includes("rolls")) {
        cfg[key] = normQuantity(select.value || optText);
      } else {
        cfg[key] = normValueByKey(key, optText);
      }
    });
    return cfg;
  }

  const KEY_ALIASES = {
    size: ["size", "interior_dimensions", "interior_dimension", "interior dimensions"],
    printed_sides: ["printed_sides", "printed_side", "printed sides"],
    lamination: ["lamination", "laminate", "finish"],
    laminate: ["lamination", "laminate", "finish"],
    finish: ["lamination", "laminate", "finish"],
  };

  function getRowValue(row, key) {
    const keys = KEY_ALIASES[key] || [key];
    for (const k of keys) {
      if (row[k] != null) return row[k];
    }
    return null;
  }

  function findRow(grid, cfg) {
    const keys = Object.keys(cfg);

    return grid.find((row) =>
      keys.every((k) => {
        const selectedVal = cfg[k];
        const rowVal = getRowValue(row, k);
        if (rowVal == null) return false;

        if (typeof selectedVal === "number")
          return Number(rowVal) === selectedVal;

        return normValueByKey(k, rowVal) === selectedVal;
      })
    );
  }

  let grid = [];

  function updateFromGrid() {
    if (!grid.length) return;

    const cfg = readSelection();
    let row = findRow(grid, cfg);

    const printedSides = cfg.printed_sides;

    if (!row && printedSides === "blank") {
      const fallbackCfg = { ...cfg, printed_sides: "outside only" };
      const outsideRow = findRow(grid, fallbackCfg);

      if (outsideRow) {
        let qty = 1;
        const qtyKey = Object.keys(cfg).find(
          (k) => k.includes("quantity") || k.includes("rolls")
        );
        if (qtyKey && typeof cfg[qtyKey] === "number") {
          qty = cfg[qtyKey];
        }

        const baseUnit = Number(outsideRow.unit_price);
        const unit = baseUnit * 0.85;
        const total = unit * qty;

        renderPrices(unit, total);
        setHiddenPackoraPricing(unit, total, cfg);
        return;
      }
    }

    if (!row) {
      console.warn("[Packora JSON] No matching row for:", cfg);
      renderEmpty();
      setHiddenPackoraPricing(null, null, cfg);
      return;
    }

    const unit = Number(row.unit_price);
    const total = Number(row.total_price);

    renderPrices(unit, total);
    setHiddenPackoraPricing(unit, total, cfg);
  }

  fetch(pricingUrl)
    .then((res) => res.json())
    .then((data) => {
      grid = Array.isArray(data) ? data : Array.isArray(data.rows) ? data.rows : [];
      updateFromGrid();

      pricingFields.forEach(({ select }) => {
        select.addEventListener("change", updateFromGrid);
      });
    })
    .catch((err) => {
      console.error("[Packora JSON] Failed to load JSON:", pricingUrl, err);
      renderEmpty();
    });
});
// Packora – keep hidden line-item properties in sync with configurator
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.custom-product-section');
  if (!root) return;

  function getSelectText(selector) {
    var el = root.querySelector(selector);
    if (!el) return '';

    // Native <select>
    if (el.tagName === 'SELECT') {
      var opt = el.options[el.selectedIndex];
      return opt ? opt.textContent.trim() : '';
    }

    // If your custom dropdown stores a label
    var lbl = el.getAttribute('data-selected-label');
    if (lbl) return lbl.trim();

    return (el.value || el.textContent || '').trim();
  }

  function setHidden(id, value) {
    var input = root.querySelector('#' + id);
    if (!input) return;
    input.value = value || '';
  }

  function syncPackoraProps() {
    // Read current configurator choices
    var sizeText = getSelectText('[data-pk-option="size"] select, [data-pk-option="size"]');
    var materialText = getSelectText('[data-pk-option="material"] select, [data-pk-option="material"]');
    var sidesText = getSelectText('[data-pk-option="sides"] select, [data-pk-option="sides"]');

    var qtyEl = root.querySelector(
      '[data-pk-option="quantity"] input,' +
      '[data-pk-option="quantity"] select,' +
      '[data-pk-option="quantity"]'
    );
    var qtyVal = qtyEl ? (qtyEl.value || qtyEl.textContent || '').trim() : '';

    // Read Packora price UI
    var eachEl = root.querySelector('.pk-subtotal-each');
    var subtotalEl = root.querySelector('.pk-subtotal-total');
    var eachText = eachEl ? eachEl.textContent.trim() : '';
    var subtotalText = subtotalEl ? subtotalEl.textContent.trim() : '';

    // Push into hidden inputs (line-item properties)
    setHidden('pk-prop-size', sizeText);
    setHidden('pk-prop-material', materialText);
    setHidden('pk-prop-sides', sidesText);
    setHidden('pk-prop-quantity', qtyVal);
    setHidden('pk-prop-unit-price', eachText);
    setHidden('pk-prop-subtotal', subtotalText);
  }

  // Listen for configurator changes
  var watched = root.querySelectorAll(
    '[data-pk-option="size"] select,' +
    '[data-pk-option="material"] select,' +
    '[data-pk-option="sides"] select,' +
    '[data-pk-option="quantity"] select,' +
    '[data-pk-option="quantity"] input'
  );
  for (var i = 0; i < watched.length; i++) {
    watched[i].addEventListener('change', syncPackoraProps);
    watched[i].addEventListener('input', syncPackoraProps);
  }

  // Also resync whenever the Packora price UI changes
  var display = root.querySelector('.pk-subtotal-display');
  if (display && window.MutationObserver) {
    var mo = new MutationObserver(syncPackoraProps);
    mo.observe(display, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // Initial snapshot
  syncPackoraProps();
});
// Packora — push configurator selections into line item properties
document.addEventListener('DOMContentLoaded', function () {
  // Only run on product pages that actually have the Packora configurator
  var sizeEl      = document.querySelector('[data-pk-option="size"] select');
  var materialEl  = document.querySelector('[data-pk-option="material"] select');
  var sidesEl     = document.querySelector('[data-pk-option="sides"] select');
var qtyEl = document.querySelector('[data-pk-option="quantity"] select, [data-pk-option="quantity"] input');
  if (!sizeEl && !materialEl && !sidesEl && !qtyEl) {
    // No Packora UI here, bail out.
    return;
  }

  // Find the product form that posts to /cart/add
  var productForm = document.querySelector('form[action*="/cart/add"]');
  if (!productForm) return;

  // Helper: create/update a hidden line-item property
  function setProp(name, value) {
    if (value == null || value === '') return;

    var selector = 'input[name="properties[' + name + ']"]';
    var input = productForm.querySelector(selector);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      productForm.appendChild(input);
    }

    input.value = value;
  }

  productForm.addEventListener('submit', function () {
    // Read current UI selections
    var sizeValue     = sizeEl      ? sizeEl.options[sizeEl.selectedIndex].text.trim()     : '';
    var materialValue = materialEl  ? materialEl.options[materialEl.selectedIndex].text.trim() : '';
    var sidesValue    = sidesEl     ? sidesEl.options[sidesEl.selectedIndex].text.trim()    : '';
    var qtyValue      = qtyEl       ? qtyEl.value : '';

    // Price snapshot from your Packora pricing UI (if present)
    var eachEl     = document.querySelector('.pk-price-main, .pk-subtotal-each');
    var subtotalEl = document.querySelector('.pk-subtotal-total');

    var eachText     = eachEl     ? eachEl.textContent.trim()     : '';
    var subtotalText = subtotalEl ? subtotalEl.textContent.trim() : '';

    // Write Packora-specific line item properties
    setProp('Packora - Size',          sizeValue);
    setProp('Packora - Material',      materialValue);
    setProp('Packora - Printed Sides', sidesValue);
    setProp('Packora - Quantity',      qtyValue);

    // Optional: price snapshot (will be refined when we do proper pricing override)
    setProp('Packora - Unit Price', eachText);
    setProp('Packora - Subtotal',    subtotalText);
  });
});
// Packora – Upload Now routing (Custom Shipping Boxes) – use PackoraUpload + sync snapshot
document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/products/custom-shipping-boxes')) return;

  var uploadLink = document.querySelector('[data-packora-upload-link], .pk-upload-now, [data-packora-upload-now]');
  if (!uploadLink) return;

  function forceSnapshotSync() {
    if (window.Packora && typeof window.Packora.syncSnapshot === 'function') {
      window.Packora.syncSnapshot();
    }
  }

  uploadLink.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    forceSnapshotSync();

    if (window.PackoraUpload && typeof window.PackoraUpload.goToUploadArtwork === 'function') {
      window.PackoraUpload.goToUploadArtwork();
      return;
    }

    if (window.PackoraUpload && typeof window.PackoraUpload.buildUploadUrl === 'function') {
      var url = window.PackoraUpload.buildUploadUrl();

      // hard guarantee variant is present too (if your upload page uses it)
if (url.indexOf('variant=') === -1) {
  var variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
  if (variantInput && variantInput.value) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variantInput.value);
  }
}

      // hard guarantee handle is present
      if (url.indexOf('handle=') === -1) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'handle=' + encodeURIComponent('custom-shipping-boxes');
      }

      window.location.href = url;
      return;
    }

    window.location.href = '/pages/upload-artwork?handle=' + encodeURIComponent('custom-shipping-boxes');
  }, true);
});
